"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _SelectField = _interopRequireDefault(require("./SelectField"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var CountryField = function CountryField(_ref) {
  var id = _ref.id,
    countries = _ref.countries,
    errorMessage = _ref.errorMessage,
    hideErrorLabel = _ref.hideErrorLabel,
    hideLabel = _ref.hideLabel,
    includeJapan = _ref.includeJapan,
    labelId = _ref.labelId,
    placeholderId = _ref.placeholderId,
    required = _ref.required,
    styleContainer = _ref.styleContainer,
    styleInput = _ref.styleInput,
    styleInputError = _ref.styleInputError,
    styleWrapper = _ref.styleWrapper;
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var options = (0, _react.useMemo)(function () {
    var countriesOptions = [_react["default"].createElement("option", {
      key: 0,
      value: "",
      disabled: true
    }, formatMessage({
      id: placeholderId
    }))];
    return countries.forEach(function (country) {
      country.countryCode === 'JP' && !includeJapan || countriesOptions.push(_react["default"].createElement("option", {
        key: country.countryCode,
        value: country.countryCode
      }, country.name));
    }), countriesOptions;
  }, [countries]);
  return _react["default"].createElement(_SelectField["default"], {
    id: id,
    errorMessage: errorMessage,
    hideErrorLabel: hideErrorLabel,
    hideLabel: hideLabel,
    labelId: labelId,
    required: required,
    styleContainer: styleContainer,
    styleInput: styleInput,
    styleInputError: styleInputError,
    styleWrapper: styleWrapper
  }, options);
};
CountryField.defaultProps = {
  id: 'country',
  styleContainer: {},
  styleInput: {},
  styleInputError: {},
  styleWrapper: {}
};
var _default = exports["default"] = CountryField;